// src/pages/MieBozzePage.js
// ═══════════════════════════════════════════════════════════════════════════
// LE MIE BOZZE (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Tutto quello che si è iniziato a compilare SU QUESTO DISPOSITIVO e non si è ancora
// salvato (utils/bozzeLocali.js): rapportini, sopralluoghi, interventi di manutenzione,
// giorni del giornale, richieste di materiale, richieste NF, verbali, segnalazioni, rientri.
//  • «Vai» apre la pagina (o la scheda della commessa) del modulo: lì compare l'avviso con
//    «Riprendi» (nelle schede della commessa subito, negli altri riaprendo il modulo);
//  • «Elimina bozza» la cancella (con conferma).
// Le bozze stanno sul dispositivo, non nel database: su un altro telefono o computer non ci
// sono. Si cancellano da sole quando il modulo viene salvato, o dopo 30 giorni.
// ═══════════════════════════════════════════════════════════════════════════
import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { useBozzeCon, cancellaBozza, quandoBozza } from "../utils/bozzeLocali";
import { confirm } from "../utils/confirm";

const TIPI = {
  rapportino: { icona: "📋", nome: "Rapportino" },
  sopralluogo: { icona: "🔍", nome: "Sopralluogo" },
  manutenzione: { icona: "🔧", nome: "Intervento di manutenzione" },
  giornale: { icona: "📅", nome: "Giornale di cantiere" },
  richiestaMateriali: { icona: "📦", nome: "Richiesta materiali" },
  richiestaMagazzino: { icona: "📦", nome: "Richiesta al magazzino" },
  nf: { icona: "🧾", nome: "Richiesta NF" },
  verbale: { icona: "📝", nome: "Verbale" },
  segnalazione: { icona: "📣", nome: "Segnalazione cliente" },
  rientro: { icona: "↩️", nome: "Rientro materiali" },
};
const tipoDi = (chiave) => String(chiave).split("|")[1] || "";
// nelle schede della commessa l'avviso con «Riprendi» compare subito; negli altri moduli
// si vede riaprendo il modulo (nuovo o la modifica di quel documento)
const AVVISO_SUBITO = new Set(["rapportino", "sopralluogo", "manutenzione", "giornale"]);

export default function MieBozzePage({ onNavigate }) {
  const { currentUser } = useAuth();
  const lista = useBozzeCon(`${currentUser?.uid || "?"}|`);

  return (
    <div style={{ padding: 24, maxWidth: 820, overflowY: "auto", height: "100%", boxSizing: "border-box" }}>
      <h2 style={{ fontSize: 20, fontWeight: 700, margin: "0 0 4px" }}>📝 Le mie bozze</h2>
      <p style={{ fontSize: 13, color: "#6b7280", margin: "0 0 18px", lineHeight: 1.5 }}>
        Quello che hai iniziato a compilare su questo dispositivo e non hai ancora salvato. Premi «Vai»: si apre la
        pagina giusta e, riaprendo il modulo, trovi «Riprendi». Le bozze si cancellano da sole quando salvi il
        modulo, o dopo 30 giorni. Su un altro telefono o computer non ci sono.
      </p>

      {lista.length === 0 ? (
        <div style={{ textAlign: "center", padding: "50px 20px", color: "#9ca3af", background: "#fff", border: "1px dashed #e5e7eb", borderRadius: 12 }}>
          <div style={{ fontSize: 34, marginBottom: 8 }}>✅</div>
          <div style={{ fontSize: 14, fontWeight: 600, color: "#6b7280" }}>Nessuna bozza in sospeso</div>
          <div style={{ fontSize: 12, marginTop: 4 }}>Se il telefono chiude Nexiora mentre compili un modulo, lo ritrovi qui.</div>
        </div>
      ) : lista.map(b => {
        const tipo = tipoDi(b.chiave);
        const t = TIPI[tipo] || { icona: "📄", nome: "Modulo" };
        const vai = b.info?.vai;
        return (
          <div key={b.chiave} style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", background: "#fff",
            border: "1px solid #e5e7eb", borderLeft: "4px solid #7c3aed", borderRadius: 10, padding: "12px 14px", marginBottom: 10 }}>
            <span style={{ fontSize: 22 }}>{t.icona}</span>
            <div style={{ flex: 1, minWidth: 200 }}>
              <div style={{ fontSize: 13.5, fontWeight: 700, color: "#111827" }}>{b.info?.titolo || t.nome}</div>
              <div style={{ fontSize: 11.5, color: "#6b7280", marginTop: 2 }}>
                {t.nome} · salvata su questo dispositivo il {quandoBozza(b.salvataIl)}
                {!AVVISO_SUBITO.has(tipo) && " · riapri il modulo per riprenderla"}
              </div>
            </div>
            {vai && onNavigate && (
              <button type="button" onClick={() => onNavigate(vai)}
                style={{ padding: "7px 14px", borderRadius: 7, border: "1px solid #7c3aed", background: "#7c3aed", color: "#fff", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "'Inter',sans-serif" }}>
                Vai →
              </button>
            )}
            <button type="button"
              onClick={async () => { if (await confirm("Eliminare la bozza? Quello che avevi scritto e non salvato andrà perso.", { type: "danger", confirmLabel: "Elimina bozza" })) cancellaBozza(b.chiave); }}
              style={{ padding: "7px 12px", borderRadius: 7, border: "1px solid #fca5a5", background: "#fff", color: "#dc2626", fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "'Inter',sans-serif" }}>
              Elimina bozza
            </button>
          </div>
        );
      })}
    </div>
  );
}
